import React from 'react';

const controlStyles = { fontSize: 10 };

interface Props {
  layout: string;
  orientation: string;
  linkType: string;
  stepPercent: number;
  setLayout: (layout: string) => void;
  setOrientation: (orientation: string) => void;
  setLinkType: (linkType: string) => void;
  setStepPercent: (percent: number) => void;
}

export default function LinkControls({
  layout,
  orientation,
  linkType,
  stepPercent,
  setLayout,
  setOrientation,
  setLinkType,
  setStepPercent,
}: Props) {
  return (
    <div style={controlStyles}>
      {/* eslint-disable-next-line jsx-a11y/label-has-for */}
      <label>layout:</label>&nbsp;
      <select onClick={(e) => e.stopPropagation()} onChange={(e) => setLayout(e.target.value)} value={layout}>
        <option value="cartesian">cartesian</option>
        <option value="polar">polar</option>
      </select>
      &nbsp;&nbsp;
      {/* eslint-disable-next-line jsx-a11y/label-has-for */}
      <label>orientation:</label>&nbsp;
      <select
        onClick={(e) => e.stopPropagation()}
        onChange={(e) => setOrientation(e.target.value)}
        value={orientation}
        disabled={layout === 'polar'}
      >
        <option value="vertical">vertical</option>
        <option value="horizontal">horizontal</option>
      </select>
      &nbsp;&nbsp;
      {/* eslint-disable-next-line jsx-a11y/label-has-for */}
      <label>link:</label>&nbsp;
      <select onClick={(e) => e.stopPropagation()} onChange={(e) => setLinkType(e.target.value)} value={linkType}>
        <option value="diagonal">diagonal</option>
        <option value="step">step</option>
        <option value="curve">curve</option>
        <option value="line">line</option>
      </select>
      {linkType === 'step' && layout !== 'polar' && (
        <>
          &nbsp;&nbsp;
          {/* eslint-disable-next-line jsx-a11y/label-has-for */}
          <label>step:</label>&nbsp;
          <input
            onClick={(e) => e.stopPropagation()}
            type="range"
            min={0}
            max={1}
            step={0.1}
            onChange={(e) => setStepPercent(Number(e.target.value))}
            value={stepPercent}
            disabled={linkType !== 'step' || layout === 'polar'}
          />
        </>
      )}
    </div>
  );
}
